import { createStore } from '@'

export const $formValues = createStore('form:values')
export const $formLoading = createStore('form:loading')
